import { tv } from '~/utils/tv'

export const TagRootVariants = tv({
  base: `
  flex items-center justify-center h-small min-w-small rounded-pill px-twopulse gap-halfpulse max-w-[16rem]
  `,
  variants: {
    variants: {
      onSale: 'bg-labelling-fill-onsale',
      principal: 'bg-labelling-fill-principal',
      secondary: 'bg-labelling-fill-secondary',
      clubeRaia: 'bg-labelling-fill-clube',
      clubeDrogasil: 'bg-labelling-fill-clube',
      assinatura: 'bg-labelling-fill-assinatura',
      medicamentoGeladeira: 'bg-labelling-fill-refrigerate',
      receitaObrigatoria: 'bg-labelling-fill-prescription',
      generico: 'bg-labelling-fill-generico',
      referencia: 'bg-labelling-fill-referencia',
      similar: 'bg-labelling-fill-similar',
      stix: 'bg-labelling-fill-stix',
    },
  },
})
